<template>
  <collapse :active-index="0">
    <collapse-item body-classes="px-0 pb-1">
      <template v-if="collapse" slot="title">
        <h3 class="mb-0">{{ title }}</h3>
      </template>
      <template v-else slot="header">
        <h3 class="mb-0 d-inline-block">{{ title }}</h3>
      </template>

      <div>
        <div class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
          <el-select v-model="pagination.perPage" class="select-primary pagination-select mt-1" placeholder="Per page">
            <el-option
              v-for="item in pagination.perPageOptions"
              :key="item"
              :label="item"
              :value="item"
              class="select-primary"
            >
            </el-option>
          </el-select>

          <base-input class="mt-1">
            <el-select v-model="stateFilter" class="select-primary" placeholder="Estado" value-key="value">
              <el-option :value="null" class="select-primary" label="Estado" />
              <el-option
                v-for="item in stateOptions"
                :key="item.label"
                :label="item.label"
                :value="item.filter"
                class="select-primary"
              />
            </el-select>
          </base-input>

          <div>
            <base-input
              v-model="mixSearchQuery"
              class="mt-1"
              placeholder="Buscar..."
              prepend-icon="fas fa-search"
            ></base-input>
          </div>
        </div>
      </div>

      <div class="table-responsive">
        <el-table :data="queriedData" header-row-class-name="thead-light" row-key="id" @sort-change="sortChange">
          <el-table-column type="expand">
            <template #default="{ row }">
              <ul class="list-group list-group-flush list my--3">
                <li v-for="item in row.items" :key="item.id" class="list-group-item px-0">
                  <div class="align-items-center">
                    <div class="row">
                      <div class="col-md-1 col-sm-12">{{ item.article.code }}</div>
                      <div class="col-md-3 col-sm-12">
                        <span class="font-weight-bold">
                          {{ item.quantity }}
                        </span>
                        &nbsp;x&nbsp;
                        <span>{{ item.article.description }}</span>
                      </div>
                    </div>
                  </div>
                </li>
                <li v-if="row.comment" class="list-group-item px-0">
                  <div class="align-items-center">
                    <div class="row">
                      <div class="col-md-1 col-sm-12">Razón:</div>
                      <div class="col-md-3 col-sm-12">
                        <span class="text-justify font-italic">{{ row.comment }}</span>
                      </div>
                    </div>
                  </div>
                </li>
                <li v-if="!row.items.length" class="list-group-item px-0">Sin artículos.</li>
              </ul>
            </template>
          </el-table-column>

          <el-table-column label="Cod." min-width="150px" prop="code" sortable>
            <template #default="{ row }">
              <span v-if="row.code">{{ row.code }}</span>
              <span v-else> {{ row.adjustCode }}</span>
            </template>
          </el-table-column>

          <el-table-column label="Fecha" min-width="130px" prop="date" sortable>
            <template #default="{ row }">
              {{ row.date | date('DD/MM/YYYY') }}
            </template>
          </el-table-column>

          <el-table-column label="Tipo" min-width="120px" prop="type" sortable>
            <template #default="{ row }">
              <span v-if="row.type">{{ row.type.label.substring(0, 6) }}</span>
              <span v-else>-</span>
            </template>
          </el-table-column>

          <el-table-column label="Autor" min-width="140px" prop="user" sortable>
            <template #default="{ row }">
              <span v-if="row.user">{{ row.user.name }}</span>
            </template>
          </el-table-column>

          <el-table-column label="Campaña" min-width="180px" prop="campaign" sortable>
            <template #default="{ row }">
              <span v-if="row.campaign">{{ row.campaign.name }}</span>
            </template>
          </el-table-column>

          <el-table-column label="Productor" min-width="180px" prop="producer" sortable>
            <template #default="{ row }">
              <div>{{ (row.producer && row.producer.businessName) || row.producerName || '—' }}</div>
            </template>
          </el-table-column>

          <el-table-column label="Dist. de Salida" min-width="200px" prop="from" sortable>
            <template #default="{ row }">
              <div v-if="row.distributorFrom">{{ row.distributorFrom.name }}</div>
              <div v-else class="font-italic">{{ MAIN_DEPOSIT_LABEL }}</div>
            </template>
          </el-table-column>

          <el-table-column label="Dist. de Entrada" min-width="200px" prop="to" sortable>
            <template #default="{ row }">
              <div v-if="row.distributorTo">{{ row.distributorTo.name }}</div>
              <div v-else class="font-italic">{{ MAIN_DEPOSIT_LABEL }}</div>
            </template>
          </el-table-column>

          <el-table-column align="right" label="" min-width="140px">
            <div slot-scope="{ row }" class="d-flex">
              <div v-if="!row.deletedAt">
                <button
                  v-if="$can('confirm', 'delivery_notes') && row.compliance === false"
                  title="Confirmar"
                  class="btn base-button btn-outline-success btn-sm"
                  @click="confirmDeliveryNote(row.id)"
                >
                  <i class="fas fa-check"></i>
                </button>
                <button
                  v-if="$can('destroy', 'delivery_notes')"
                  title="Eliminar"
                  class="btn base-button btn-outline-danger btn-sm"
                  @click="deleteDeliveryNote(row)"
                >
                  <i class="fas fa-trash"></i>
                </button>
              </div>
            </div>
          </el-table-column>
        </el-table>
      </div>

      <div slot="footer" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
        <div class="">
          <p class="card-category">Mostrando {{ from + 1 }} a {{ to }} de un total de {{ pagination.total }} remitos</p>
        </div>
        <base-pagination
          v-model="pagination.currentPage"
          :per-page="pagination.perPage"
          :show-first-page-button="true"
          :show-last-page-button="true"
          :total="pagination.total"
          class="pagination-no-border"
          @input="changePage"
        >
        </base-pagination>
      </div>
    </collapse-item>
  </collapse>
</template>

<script>
import { Table, TableColumn, DropdownMenu, DropdownItem, Dropdown, Select, Option } from 'element-ui';
import swal from 'sweetalert2';
import { mapState } from 'vuex';

import { BasePagination } from '@/components';
import Collapse from '@/components/Collapse/Collapse';
import CollapseItem from '@/components/Collapse/CollapseItem';

import PaginationOnServerMixin from '@/mixins/paginationOnServerMixin';

import { MAIN_DEPOSIT_LABEL, TRASHED } from '@/util/constants/deliveryNotes';

export default {
  name: 'DeliveryNotesTable',
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    BasePagination,
    Collapse,
    CollapseItem,
  },

  mixins: [PaginationOnServerMixin],
  props: {
    title: {
      type: String,
      default: 'Todos los remitos',
    },

    collapse: {
      type: Boolean,
      default: false,
    },

    filterAuthor: {
      type: Number,
      default: null,
    },

    filterCampaign: {
      type: Number,
      default: null,
    },
  },

  data() {
    return {
      tableData: [],
      modelName: 'deliveryNote',
      MAIN_DEPOSIT_LABEL,
      stateFilter: null,
      stateOptions: [
        { filter: { name: 'compliance', value: true }, label: 'Confirmados' },
        { filter: { name: 'compliance', value: false }, label: 'Pendientes' },
        { filter: { name: TRASHED, value: 'only' }, label: 'Eliminados' },
      ],
    };
  },

  computed: {
    ...mapState('models/campaign', ['campaigns']),
  },

  watch: {
    filterCampaign: {
      immediate: true,
      handler() {
        this.fetchTableData();
      },
    },

    stateFilter: {
      handler() {
        this.fetchTableData();
      },
    },
  },

  methods: {
    fetchTableData() {
      this.pagination.perPage = this.perPage || this.pagination.perPage;
      this.pagination.currentPage = this.page || this.pagination.currentPage;

      const params = {
        'filter[campaign]': this.filterCampaign,
        'filter[search]': this.mixSearchQuery,
        perPage: this.pagination.perPage,
        page: this.pagination.currentPage,
        sort: this.sort || this.defaultSort,
        ...(this.stateFilter ? { [`filter[${this.stateFilter.name}]`]: this.stateFilter.value } : null),
      };

      this.$services
        .resource('delivery_notes')
        .get(params)
        .then((res) => {
          this.setMeta(res.data.meta);
          return res.data.data;
        })
        .then((data) => (this.tableData = data.deliveryNotes));
    },

    confirmDeliveryNote(id) {
      this.$services
        .resource('delivery_notes')
        .confirm(id)
        .then(() => {
          swal({
            title: 'Remito confirmado con éxito',
            type: 'success',
            confirmButtonText: 'Aceptar',
          }).then(() => this.fetchTableData());
        });
    },

    deleteDeliveryNote(row) {
      swal({
        title: 'Se eliminará el remito',
        type: 'warning',
        text: `Para confirmar ingrese el código del remito`,
        input: 'text',
        inputPlaceholder: row.code || row.adjustCode,
        showCancelButton: true,
        confirmButtonText: 'Sí, eliminar',
        buttonsStyling: false,
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-secondary',
        cancelButtonText: 'Cancelar',
      }).then((result) => {
        if (result.value && (result.value === row.code || result.value === row.adjustCode)) {
          this.$services
            .resource('delivery_notes')
            .delete(row.id, { force: 1 })
            .then(() => {
              this.fetchTableData();
            })
            .then(() => swal('Listo!', 'El remito ha sido eliminado', 'success'));
        }
      });
    },
  },
};
</script>

<style scoped>
::v-deep .el-table__expand-column .cell {
  width: 20px;
}

::v-deep .el-table__expanded-cell p {
  word-break: break-word;
  white-space: normal;
}
</style>
